import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.adminInquiries.inquiryList;
export const adminInquiryListSelector = (state: RootState) => getState(state).data?.tableData || [];
export const adminInquiryListPaginationSelector = (state: RootState) =>
  getState(state).data?.pagination;
export const adminInquiryListIsLoadingSelector = (state: RootState) => getState(state).isLoading;
export const adminInquiryListErrorSelector = (state: RootState) => getState(state).error;
